import { NotificationCustomFieldsMultiselectValues } from '~/components/AirNotifications/components/NotificationCustomFieldsMultiselectValues';
import { NotificationCustomFieldValue } from '~/components/AirNotifications/components/NotificationCustomFieldValue';
import {
  isSingleValueSet,
  isSingleValueUnset,
  type NotificationCustomFieldType,
} from '~/components/AirNotifications/utils/types';
import { customFieldIconMap } from '~/constants/customFieldIconMap';
import { usePrivateCustomFieldsContext } from '~/providers/PrivateCustomFieldsProvider';

export type NotificationCustomFieldsProps = {
  customFields: NotificationCustomFieldType[];
};

export const NotificationCustomFields = ({ customFields }: NotificationCustomFieldsProps) => {
  const { customFields: customFieldsContext } = usePrivateCustomFieldsContext();

  return (
    <div className="flex flex-col gap-3">
      {customFields.map((customField) => {
        const Icon = customFieldIconMap[customField.type.title];
        const customFieldTitle = customFieldsContext?.find((cField) => cField.id === customField.id)?.name;

        return (
          <div className="flex flex-col gap-1" data-id={customField.id} key={customField.id}>
            <div className="flex items-center gap-1 p-1 pl-0 ads:text-metadata text-pigeon-400">
              <Icon className="size-4" />
              <span className="font-medium text-12">{customFieldTitle}</span>
            </div>
            <div className="flex gap-1">
              {isSingleValueSet(customField) && <NotificationCustomFieldValue state="set" customField={customField} />}
              {isSingleValueUnset(customField) && <p className="ads:text-metadata text-12 text-gray-8">None</p>}

              {(customField.set?.values || customField.unset?.values) && (
                <NotificationCustomFieldsMultiselectValues
                  newValues={customField.set?.values ?? []}
                  removedValues={customField.unset?.values ?? []}
                />
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
